export default __webpack_public_path__ + "static/fall33-ef127f0c7ccba3c1b7ad610a78d7d9f0.webp";